import { Component } from '@angular/core';
import { TranslateService, LangChangeEvent } from "@ngx-translate/core";

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.less']
})
export class AppComponent {
  
  lang: string = localStorage.getItem('lang');

  constructor(
    private translate: TranslateService
  ) {
    this.lang ? translate.use(this.lang) : translate.use('en');
    this.translate.onLangChange
      .subscribe((event: LangChangeEvent) => {
        this.translate.use(event.lang);
        localStorage.setItem('lang', event.lang);
      });
  }
  
}
